// src/pages/ChatbotSettings/CreateChatbotName.js
import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { TextField, Typography, Box } from '@mui/material'; 
import axios from "axios";
import backendURL from "../../config";
import { useNavigate, useParams } from 'react-router-dom';

const CreateChatbotName = forwardRef(({ onComplete, onError }, ref) => {
    const [chatbotName, setChatbotName] = useState('');
    const [nameError, setNameError] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    // const token = localStorage.getItem("access_token"); // Commented out if not used in handleSave Option 1
    const token = localStorage.getItem("access_token");
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const navigate = useNavigate();

    useEffect(() => {
        try {
            const userStr = localStorage.getItem('user');
            if (userStr) {
                const userData = JSON.parse(userStr);
                if (userData.llm_settings && userData.llm_settings.chatbot_name) {
                    setChatbotName(userData.llm_settings.chatbot_name);
                }
            }
        } catch (e) {
            console.error("Error reading initial chatbot name:", e);
        }
    }, []);

    const validateName = (name) => {
        if (!name.trim()) {
            return "Chatbot name cannot be empty.";
        }
        if (name.trim().length > 30) {
            return "Chatbot name must be 30 characters or less.";
        }
        return "";
    };

    const handleSave = async () => { // Made handleSave async even for Option 1 for consistency
        const errorMsg = validateName(chatbotName);
        if (errorMsg) {
            setNameError(errorMsg);
            if (onError) onError(errorMsg);
            return false;
        }
        setNameError('');
        setIsSaving(true);

        try {
            await axios.post(`${backendURL}/chatbots`, {
            chatbot_name: chatbotName.trim()}, { headers });
            if (onComplete) onComplete({ nextSlug:  'set-avatar'  }); // Or get next slug dynamically
            // setIsSaving(false); // Moved to finally block
            return true;
        } catch (error) {
            const message = error.response?.data?.message || error.message || "Error saving chatbot name.";
            console.error("Save chatbot name error:", message);
            setNameError(message);
            if (onError) onError(message);
            return false;
        } finally {
            setIsSaving(false);
        }
    };

    useImperativeHandle(ref, () => ({
        triggerSave: handleSave
    }));

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, p: 2, width: '100%' /* Ensure Box takes width */ }}>
            <Typography variant="h6">Name Your Chatbot</Typography>
            <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center', mb: 1 }}>
                This name will be used to identify your chatbot within the platform and can be shown to users.
            </Typography>
            <TextField
                fullWidth
                label="Chatbot Name"
                value={chatbotName}
                onChange={(e) => {
                    setChatbotName(e.target.value);
                    if (nameError) setNameError('');
                }}
                disabled={isSaving}
                inputProps={{ maxLength: 30 }}
                sx={{
                    '& .MuiInputBase-root': {
                        border: 'none',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        border: 'none', // Removes the default outline border
                    },
                }}
            />

        </Box>
    );
});

export default CreateChatbotName;